<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header
        entity="prestation_reference"
        :edit="edit"
        :save="save"
        :cancel="cancel"
        :remove="remove"
      >
        <h1 class="title">
          <breadcrumb
            location="/prestationreferences"
            :text="$t('entities.prestationReference')"
          ></breadcrumb>
          {{ prestationreference.name }}
        </h1>
      </page-header>
      <div class="panel">
        <div class="panel-heading has-background-primary">
          <span>{{ $t("common.information") }}</span>
        </div>
        <div class="panel-block is-block no-border">
          <div class="columns">
            <div class="column is-half" v-if="prestationreference">
              <text-field
                :cy-data="$t('common.name')"
                :label="$t('common.name')"
                v-model="prestationreference.name"
                required
              ></text-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "prestationreference",
  props: ["id"],
  data() {
    return {
      prestationreference: {
        name: null,
        id: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      editMode: "states/isEdition",
      getRights: "auth/getRights",
      user: "auth/getUser",
    }),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      return axios.get(`/prestationreference/${this.id}`).then((r) => {
        this.prestationreference = r.data;
      });
    },
    remove() {
      return this.$awn.confirm(
        "Êtes-vous sûr de vouloir supprimer cet élément ?",
        () =>
          axios
            .delete(`/prestationreference/${this.id}`, this.prestationreference)
            .then((response) => {
              if (response.data.success) {
                this.$router.replace("/prestationreferences");
              }
            })
      );
    },
    save() {
      return this.$validator.validateAll().then((result) => {
        if (result) {
          return axios
            .put(`/prestationreference/${this.id}`, this.prestationreference)
            .then((response) => {
              if (response.data.success) {
                this.cancel();
              }
            });
        }
        return Promise.resolve();
      });
    },
    edit() {
      this.$store.dispatch("states/setEdition", true);
    },
    cancel() {
      this.fetchData().then(() => {
        this.$store.dispatch("states/setEdition", false);
      });
    },
  },
};
</script>
